import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const createAgentService = async (payload) => {
    return (await axiosInstance.post(APIROUTE.agent, payload)).data;
};

export const getAgentService = async (signal) => {
    return (await axiosInstance.get(`${APIROUTE.agent}`, signal)).data; 
}

export const getAgentLoginUserService = async (signal) => {
    return (await axiosInstance.get(`${APIROUTE.loginUser}`, signal)).data;
}

export const getGameTypeEquationByAgentIdService = async (Id, signal) => { 
    let agentId = Id.id;
    return (await axiosInstance.get(`${APIROUTE.agent}/${agentId}`, signal)).data; 
}

export const updateAgentService = async (payload , agentId) => {
    // let filteredPayload = {
    //     "agentId" : payload.agentId,
    //     "agentName": payload.agentName,
    //     "userId": payload.userId,
    //     "finalRemainDate": payload.finalRemainDate,
    //     "Remain": payload.Remain,
    // }
    return (await axiosInstance.put(`${APIROUTE.agent}/${agentId}`, payload)).data;
}

export const addNewEquationForExistedAgent = async (payload, agentId) => {
    return (await axiosInstance.post(`${APIROUTE.agent}/${agentId}`, payload)).data;
}

// export const deleteEquationByAgentGameTypeService = async (agentId, gameTypeId) => {
//     return (await axiosInstance.delete(`${APIROUTE.currency}/${currencyId}`)).data
// }